import {ITheme} from 'contexts/ThemeContext';
import {CreateResponsiveStyle} from 'rn-responsive-styles';

export default (props: ITheme) =>
  CreateResponsiveStyle({
    container: {
      width: '100%',
      height: 96,
      borderBottomWidth: 1,
      borderBottomColor: props.colors.extraLight,
      justifyContent: 'space-between',
      flexDirection: 'row',
      marginTop: 30,
    },

    textStyle: {
      marginTop: 24,
      fontSize: 28,
      ...props.typography.mulishBold,
    },
  })();
